import styles from "./Logo.module.scss";
import InternalLink from "./InternalLink.js";

export default function Logo() {
    return (
		<InternalLink link={"/"} otherClasses={styles.logo}>
			<img className={styles.logo_image} src={"/images/logos/magicpepe_512.png"} alt={"Wizard Pepe Logo (Magic Yearn - Pepe Meme Comic)"}/>
			<span className={styles.logo_text}>  MAGIC YEARN</span>
		</InternalLink>
    );
}